import React from 'react';
import { formatCurrency } from '@/utils/formatters';

const STATUS_COLORS = {
  ok:      { bar: '#2E7D32', text: 'text-success' },
  warning: { bar: '#F57F17', text: 'text-yellow-700' },
  danger:  { bar: '#B71C1C', text: 'text-danger' },
};

export default function BudgetCategoryRow({ category, budgetValue, onBudgetChange, status }) {
  const { emoji, label } = category;
  const pct    = status ? Math.min(status.percent, 100) : 0;
  const colors = STATUS_COLORS[status?.status ?? 'ok'];

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-700">
          {emoji} {label}
        </span>
        <div className="flex items-center gap-1">
          <span className="text-warning font-bold text-xs">₹</span>
          <input
            type="number"
            value={budgetValue}
            onChange={e => onBudgetChange(e.target.value)}
            placeholder="0"
            className="w-24 text-right text-sm font-bold text-gray-800 outline-none border-b border-gray-200 focus:border-purple pb-0.5"
            aria-label={`${label} budget`}
          />
        </div>
      </div>
      {status && budgetValue && (
        <>
          <div className="progress-bar-track mb-1">
            <div
              className="h-full rounded-full transition-all duration-500"
              style={{ width: `${pct}%`, backgroundColor: colors.bar }}
              role="progressbar"
              aria-valuenow={Math.round(pct)}
              aria-valuemin={0}
              aria-valuemax={100}
            />
          </div>
          <div className="flex justify-between text-xs">
            <span className={`font-semibold ${colors.text}`}>
              {status.status === 'danger'
                ? `🔴 Over by ${formatCurrency(status.spent - status.budget)}`
                : status.status === 'warning'
                ? `🟡 ${Math.round(status.percent)}% used`
                : `✓ ${formatCurrency(status.remaining)} left`}
            </span>
            <span className="text-gray-400">{formatCurrency(status.spent)} spent</span>
          </div>
        </>
      )}
    </div>
  );
}
